/**
 * @fileoverview Source document download helper.
 *
 * Split out of `SourceDocPreview.tsx` (react-refresh/only-export-components).
 */

import { toast } from "sonner";

/**
 * Stream the source URL via fetch and trigger a browser save dialog with the
 * original filename. We can't just `<a download>` because Convex storage URLs
 * are cross-origin signed links — the browser drops the `download` attribute
 * and the file opens inline instead. Exported so the parent dialog header
 * can render its own Download button (avoids a floating overlay that covers
 * the document preview).
 */
export async function downloadSourceDoc(url: string, fileName?: string | null) {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = fileName?.trim() || "document";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (err) {
    const message =
      err instanceof Error ? err.message : "Could not download the file";
    toast.error(message);
  }
}
